import { render, staticRenderFns } from "./VerifyEmailSuccess.vue?vue&type=template&id=b13cd428&"
import script from "./VerifyEmailSuccess.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports